<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <DailySignupMemberReportTable/>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import DailySignupMemberReportTable from './DailySignupMemberReportTable.vue'

  export default {
    name: 'dailysignupreport-table',
    components: { DailySignupMemberReportTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/member/DailySignupMemberReport.vue